<script setup lang="ts">
import { PropType, defineProps } from "vue";
import ModalBox from "@/components/v2/Modal/ModalBox.vue";
import { useTasksStore } from "@/stores/v2";

// Props
defineProps({
  showModal: {
    type: Boolean,
    default: false,
  },
  toggleInstructionsModal: {
    type: Function as PropType<(payload: MouseEvent) => void>,
    required: true,
  },
});

const instructions = useTasksStore().activeTask?.description;
</script>

<template>
  <ModalBox v-if="showModal" @close="toggleInstructionsModal">
    <template #header> Instructions </template>
    <template #main>
      <p>{{ instructions }}</p>
    </template>
    <template #footer>
      <button @click="toggleInstructionsModal" type="button"
        class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10">
        Close
      </button>
    </template>
  </ModalBox>
</template>
